import {
    brands_banks_commerzbank,
    social___facebook,
    social___instagram,
    social___linkedin,
    social___youtube,
} from '@lsg/icons';
import { ReactComponent as CzFlag } from '../../assets/images/countryflags/CZ.svg';
import { ReactComponent as BgFlag } from '../../assets/images/countryflags/BG.svg';
import { ReactComponent as DeFlag } from '../../assets/images/countryflags/DE.svg';
import { ReactComponent as PlFlag } from '../../assets/images/countryflags/PL.svg';
import React from 'react';

export const socialMediaData = [
    {
        name: 'HQ Frankfurt',
        img: <DeFlag />,
        links: [
            {
                url: 'https://www.commerzbank.de/',
                icon: brands_banks_commerzbank,
            },
            {
                url: 'https://www.linkedin.com/company/commerzbank-ag/',
                icon: social___linkedin,
            },
            {
                url: 'https://www.instagram.com/commerzbankkarriere/',
                icon: social___instagram,
            },
            {
                url: 'https://www.facebook.com/commerzbank/',
                icon: social___facebook,
            },
            {
                url: 'https://www.youtube.com/user/CommerzbankPrivat',
                icon: social___youtube,
            },
        ],
    },
    {
        name: 'DTC Lodz',
        img: <PlFlag />,
        links: [
            {
                url: 'https://lodz.commerzbank.pl/',
                icon: brands_banks_commerzbank,
            },
            {
                url: 'https://www.linkedin.com/company/commerzbank-branch-in-poland',
                icon: social___linkedin,
            },
            {
                url: 'https://www.instagram.com/collabothon/',
                icon: social___instagram,
            },
            {
                url: 'https://www.facebook.com/people/Commerzbank-Centrum-Technologii-Cyfrowych-w-Polsce/100063453976458/',
                icon: social___facebook,
            },
            {
                url: 'https://www.youtube.com/@Collabothon',
                icon: social___youtube,
            },
        ],
    },
    {
        name: 'DTC Prague',
        img: <CzFlag />,
        links: [
            {
                url: 'https://commerzbank.jobs.cz/',
                icon: brands_banks_commerzbank,
            },
            {
                url: 'https://cz.linkedin.com/company/commerzbankcz',
                icon: social___linkedin,
            },
            {
                url: 'https://instagram.com/commerzbank_czechrepublic?igshid=YmMyMTA2M2Y=',
                icon: social___instagram,
            },
            {
                url: 'https://www.facebook.com/Commerzbank.Czechia/',
                icon: social___facebook,
            },
        ],
    },
    {
        name: 'DTC Sofia',
        img: <BgFlag />,
        links: [
            {
                url: 'https://sofia.commerzbank.bg//',
                icon: brands_banks_commerzbank,
            },
            {
                url: 'https://www.linkedin.com/company/commerzbankdtcsofia/',
                icon: social___linkedin,
            },
            {
                url: 'https://www.instagram.com/commerzbank_dtc_bulgaria/?hl=en',
                icon: social___instagram,
            },
            {
                url: 'https://www.facebook.com/commerzbankdtcbulgaria/',
                icon: social___facebook,
            },
            {
                url: 'https://www.youtube.com/watch?v=rE4rx3yO_Y4/@Collabothon',
                icon: social___youtube,
            },
        ],
    },
];
